module.exports = __webpack_public_path__ + "img/phone-disabled.dc51b2b0.svg";